import styled from 'styled-components';

import { IStyledIcon } from './icon.types';

export const StyledIcon = styled.svg<IStyledIcon>`
  height: ${({ size }) => size};
  color: ${({ fill }) => fill};
`;
